<template>
  <v-container>
    <h3>Send feedback or suggestion</h3>

    <v-form ref="form" v-model="form_valid" lazy-validation >
      <v-autocomplete label="Category" v-model="feedback.category_id" :items="categories" item-value="id" item-text="name" :rules="required_field_rules" />
      <v-textarea label="Your suggestion, question, or comment" v-model.trim="feedback.text" :counter="500" :rules="text_rules" />
      <v-text-field label="Name" v-model.trim="feedback.name" />
      <v-text-field label="Email" v-model.trim="feedback.email" />
      <v-btn :disabled="!form_valid" color="secondary" class="mr-1 mb-12" @click="save_feedback">Send</v-btn>

      <v-snackbar :color="snackbar.color" v-model="snackbar.show" :timeout="2000" >
        {{ snackbar.message }}
        <v-btn text @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
    </v-form>
  </v-container>
</template>

<script>
import {firebase, db} from '@/firebaseInit.js'
import browserDetect from '@/util/browser-detect.js'

export default {
  name: 'feedback',
  data: () => ({
    categories: [],
    feedback: {
      text: '',
      category_id: '',
      name: '',
      email: '',
    },
    form_valid: true,
    snackbar: {
      show: false,
      message: null,
      color: "success"
    },
    required_field_rules: [
      v => !!v || 'Required',
    ],
    text_rules: [
      v => !!v || 'Required',
      v => (!v || v.length <= 500) || 'Must be 500 characters or less',
    ],
  }),
  firestore: {
    categories: db.collection('feedback_categories').orderBy('order'),
  },
  async created() {
    const currentUser = await firebase.getCurrentUser();
    if (currentUser) {
      this.feedback.email = currentUser.email;
      this.feedback.name = currentUser.displayName;
    }
  },
  methods: {
    async save_feedback() {
      if (!this.$refs.form.validate()) return;

      const new_feedback = {
        ...this.feedback,
        category_name: this.categories.find(c => c.id == this.feedback.category_id).name,
        modified_date: firebase.firestore.FieldValue.serverTimestamp(),
        app_version: this.$appConfig.app.version,
        ...browserDetect.getProperties(),
      };
      const current_user = await firebase.getCurrentUser();
      if (current_user) {
        new_feedback.user_id = current_user.uid;
        new_feedback.user_email = current_user.email;
        new_feedback.user_email_verified = current_user.emailVerified;        
      }

      db.collection("feedback").add(new_feedback).then( () => {
        //TODO: global indicator of sync status that gets cleared after server responds
      })
      .catch(function(error) {
        this.snackbar.show = true;
        this.snackbar.message = error;
        this.snackbar.color = "error";
      });

      this.snackbar.show = true;
      this.snackbar.message = "Saved!";
      this.snackbar.color = "success";
      this.$refs.form.reset()
    },
  },
}
</script>